<template>
  <ion-content fullscreen>
    <div class="w-full h-full ion-padding">
      <ion-grid class="flex flex-column h-full justify-center">
        <ion-row center>
          <ion-col width=100>
            <ion-card class="limit-card">
              <ion-card-header class="text-center">
                <h2>
                  Nuova versione dell'app
                </h2>
              </ion-card-header>
              <ion-card-content>
                <div class="text-center ion-padding-vertical">
                  {{ messageMinVersion }}
                </div>
                <ion-button class="w-full" @click="redirectToStore">
                  Aggiorna
                </ion-button>
              </ion-card-content>
            </ion-card>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
  </ion-content>
</template>
<script lang="ts">
  import { defineComponent } from 'vue';
  import { IonContent, IonGrid, IonRow, IonCol, IonCard, IonCardContent, IonCardHeader, IonButton, isPlatform } from '@ionic/vue'
  import Storage from '@/models/Storage'

  export default defineComponent({
    components: { IonContent, IonGrid, IonRow, IonCol, IonCard, IonCardContent, IonCardHeader, IonButton },
    setup(){
      return {
        messageMinVersion: Storage.get("app-messageMinVersion")
      }
    },
    methods:{
      redirectToStore(){
        const links = Storage.get("app-linksMinversion")
        if(links){
          if(isPlatform('android')){
            window.open(links['android'], "_blank")
          } else if(isPlatform('ios')){
            window.open(links['ios'], "_blank")
          }
        }
      }
    }
  });
</script>


<style scoped>
</style>